import { ENERGY_TYPES } from '@boltenergy-be/shared'

export const BOLT_GO_PRICES = {
  [ENERGY_TYPES.electricity]: 1500,
  [ENERGY_TYPES.gas]: 2500
}
